<div class="main-container">
  @if (fg) {
  <form [formGroup]="fg" (submit)="update()">
    <div class="form-container">
      <div>
        <mat-slide-toggle formControlName="disableGlobalAffordability" class="toggle-icon">
          <span>Disable global monthly<b class="toggle-text"> net loss</b> affordability</span>
        </mat-slide-toggle>
      </div>
      <div class="info-container">
        @if (editMode) { @if (updatingInProgress) {
        <mat-spinner class="display-inline" [diameter]="20"></mat-spinner>
        } @if (!success && !updatingInProgress) {
        <button mat-stroked-button color="primary" type="submit">Save</button>
        } @if (!success && !updatingInProgress) {
        <button mat-icon-button color="accent" type="submit" (click)="toggleEditMode()" matTooltip="Cancel">
          <mat-icon>cancel</mat-icon>
        </button>
        } } @if (!editMode) { @if (!success) {
        <button mat-icon-button color="primary" type="submit" (click)="toggleEditMode()">
          <mat-icon>edit</mat-icon>
        </button>
        } @if (success) {
        <strong class="green">Changes saved</strong>
        } }
      </div>
    </div>
  </form>
  }
</div>
